'use strict';

var isAfterDay = require('../../../../_virtual/isAfterDay.js_commonjs-exports.js');
var interopRequireDefault = require('../../node_modules/@babel/runtime/helpers/interopRequireDefault.js');
var moment = require('moment');
require('./isBeforeDay.js');
require('./isSameDay.js');
var isBeforeDay = require('../../../../_virtual/isBeforeDay.js_commonjs-exports.js');
var isSameDay = require('../../../../_virtual/isSameDay.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);

(function (exports) {

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAfterDay;

var _moment = _interopRequireDefault(moment__default["default"]);

var _isBeforeDay = _interopRequireDefault(isBeforeDay.__exports);

var _isSameDay = _interopRequireDefault(isSameDay.__exports);

function isAfterDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isBeforeDay["default"])(a, b) && !(0, _isSameDay["default"])(a, b);
}
}(isAfterDay.__exports));
